
export class PgyInformation {
    pgyBeginDate: Date;
    pgyEndDate: Date;
    yearInSchool: string;
}
